export interface ComboWordGroupGq {
  readonly id: string;
  readonly name: string;
  readonly order: number;
  readonly wordItems?: string;
}

export const ComboWordGroupGqProps = `
  id
  name
  order
  wordItems
`;
